
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Payingguestnearhinjewadiitpark() {



    const cardData =
    {
        keyword: 'Paying Guest Near Hinjewadi IT ',
        heading: 'Shree Swami Samarth PG: Paying Guest Near Hinjewadi IT ',
        headingDescription: 'Shree Swami Samarth PG provides comfortable and affordable paying guest accommodation near Hinjewadi IT Park, Pune, making it an excellent choice for IT professionals and employees working in Phase 1, 2, or 3. Our PG is strategically located to reduce commuting time, ensuring quick access to major tech companies and business hubs. The rooms are well-furnished, spacious, and designed to provide a peaceful environment with facilities like high-speed WiFi, 24x7 water supply, CCTV surveillance, and hygienic home-cooked meals. Residents also benefit from regular housekeeping, disciplined management, and a homely atmosphere that balances work-life convenience. With budget-friendly rent plans and reliable amenities, Shree Swami Samarth PG near Hinjewadi IT Park offers a safe, comfortable, and hassle-free living solution for professionals seeking quality accommodation close to their workplace.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Furnished Rooms for Comfortable Living",
    "description": "PGs near Hinjewadi IT Park offer fully furnished and well-maintained rooms equipped with modern beds, wardrobes, study desks, and chairs. Options include single, twin, and triple sharing to suit different budgets and privacy needs. The rooms are spacious, airy, and designed to balance rest and productivity, making them ideal for IT professionals. Interiors are thoughtfully arranged with practical layouts that ensure convenience while also providing a homely atmosphere. With such setups, residents can enjoy stress-free living close to their workplace."
  },
  {
    "title": "Nutritious Meals Included in Rent",
    "description": "One of the biggest advantages of PGs near Hinjewadi is the availability of daily meals included in the monthly package. Residents enjoy freshly prepared, hygienic breakfast, lunch, and dinner, saving time and effort for busy professionals. Kitchens maintain strict cleanliness standards, ensuring quality and safety in food preparation. Vegetarian and customized dietary needs are also catered to in many PGs. This inclusive food facility means IT employees can focus on work without worrying about cooking or eating outside every day."
  },
  {
    "title": "High-Speed Wi-Fi and Work-Friendly Setup",
    "description": "PGs near Hinjewadi IT Park recognize the digital needs of working professionals and provide high-speed Wi-Fi across all rooms and lounges. This ensures seamless connectivity for virtual meetings, remote work, and online collaborations. Some PGs also offer co-working zones, study lounges, or common areas with charging points and proper lighting. Combined with reliable power backup, this makes living convenient for IT professionals who often need flexible working hours."
  },
  {
    "title": "24/7 Security and Safe Environment",
    "description": "Security is a top priority in Hinjewadi PGs, with features like CCTV surveillance, biometric entry, and round-the-clock staff supervision. Visitor entry is carefully regulated, ensuring privacy and peace of mind for residents. Many PGs are located within secure gated communities, adding an additional layer of safety. This makes them highly suitable for both male and female IT professionals who often work late hours and require a secure place to stay."
  },
  {
    "title": "Prime Location Near IT Hubs",
    "description": "Hinjewadi is home to the Rajiv Gandhi Infotech Park, which houses top IT companies like Infosys, Wipro, Cognizant, and TCS. Staying in PGs nearby ensures professionals save significant commuting time and energy. With offices just a short walk or quick ride away, residents can maintain a healthier work-life balance. The location also provides easy access to gyms, supermarkets, restaurants, and shopping centers, making everyday living both convenient and enjoyable."
  },
  {
    "title": "Housekeeping and Laundry Services",
    "description": "To support busy professionals, PGs near Hinjewadi provide daily housekeeping and cleaning services, ensuring rooms and bathrooms remain neat and hygienic. Laundry services are often included or available at affordable rates, saving residents valuable time. These facilities help IT professionals focus on their work and personal well-being without worrying about day-to-day chores. Clean surroundings also contribute to better health and comfort."
  },
  {
    "title": "Recreational and Community Facilities",
    "description": "Many PGs near Hinjewadi go beyond basic accommodation, offering lounges, indoor games, and community spaces for relaxation. Shared dining areas, gyms, and cultural events encourage residents to socialize and build connections. This sense of community is particularly valuable for newcomers to the city, helping them adjust quickly and avoid loneliness. Recreation after work hours ensures a balanced lifestyle where professionals can unwind and recharge."
  },
  {
    "title": "Affordable and Transparent Pricing",
    "description": "PGs near Hinjewadi IT Park are available at various price points, making them suitable for interns, freshers, and experienced professionals. Shared rooms typically start from ₹6,000–₹8,000/month, while single occupancy with premium amenities can range from ₹12,000–₹18,000/month. Rent packages usually include meals, Wi-Fi, and housekeeping, offering great value. Transparent pricing with no hidden costs ensures financial clarity, making these PGs a smart choice for IT employees seeking affordable yet comfortable living close to their workplace."
  }
],


"services": [
  {
    "name": "Paying Guest Near Hinjewadi IT Park Pune",
    "description": "Shree Swami Samarth PG offers fully furnished and professionally managed Paying Guest accommodation near Hinjewadi IT Park, Pune. Just minutes away from leading IT companies, our PG includes high-speed Wi-Fi, meals, daily housekeeping, and secure premises—ideal for tech professionals seeking comfort and convenience."
  },
  {
    "name": "PG Near Hinjewadi Phase 1",
    "description": "Located close to Phase 1, Shree Swami Samarth PG provides premium and affordable accommodation with quick access to Infosys, Wipro, and Cognizant offices. With options for single/shared rooms, AC, food, and reliable support, it’s perfect for employees or interns working in Phase 1 Hinjewadi."
  },
  {
    "name": "PG Near Hinjewadi Phase 2",
    "description": "Shree Swami Samarth PG is strategically located near Hinjewadi Phase 2, making it an ideal residence for employees at TCS, Capgemini, and Tech Mahindra. Enjoy fully equipped rooms, daily meals, and stress-free commuting—all in a quiet and safe neighborhood."
  },
  {
    "name": "PG Near Infosys Hinjewadi",
    "description": "Find your perfect stay at Shree Swami Samarth PG near Infosys Hinjewadi. Our PG offers walkable access, secure surroundings, and a professional setup including furnished rooms, food service, Wi-Fi, and peaceful working environments—tailored for Infosys employees and interns."
  },
  {
    "name": "PG Near Tech Mahindra Hinjewadi",
    "description": "Just a short ride from Tech Mahindra, Shree Swami Samarth PG ensures you live close to work while enjoying home-like comfort. We offer flexible monthly plans, AC/non-AC rooms, and balanced meals for professionals working at Tech Mahindra or nearby companies."
  },
  {
    "name": "Hostels Near Hinjewadi IT Park",
    "description": "Shree Swami Samarth operates safe, affordable, and fully serviced hostels near Hinjewadi IT Park. With facilities like 24/7 security, common lounges, dedicated workspaces, and mess food, our hostels cater to the lifestyle of working professionals and students in Pune's busiest tech zone."
  },
  {
    "name": "PG for Working Professionals Near Hinjewadi",
    "description": "Our PG near Hinjewadi is specially designed for working professionals. Shree Swami Samarth PG offers all-inclusive monthly plans with Wi-Fi, home-style food, power backup, and a peaceful setting—perfect for employees seeking focus, rest, and easy access to office zones."
  },
  {
    "name": "Affordable PG Near Hinjewadi",
    "description": "Get the best value with our Affordable PG options near Hinjewadi. Shree Swami Samarth PG offers budget-friendly shared or single rooms with food, Wi-Fi, and housekeeping included—ideal for entry-level professionals, interns, and students looking for a reliable and economical place to stay."
  },
  {
    "name": "Luxury PG Near Hinjewadi IT Park",
    "description": "Upgrade your lifestyle with our Luxury PG near Hinjewadi IT Park. Shree Swami Samarth PG features AC rooms, modern interiors, attached bathrooms, curated meals, and smart amenities—designed for executives and professionals who prefer high-end comfort near the workplace."
  },
  {
    "name": "Monthly PG Near Hinjewadi",
    "description": "Flexible stays made easy! Our Monthly PG near Hinjewadi offers fully furnished rooms, meals, and internet with simple monthly payment plans. Shree Swami Samarth PG is perfect for contractual employees, transfer cases, and anyone who needs quality accommodation with no long-term lock-ins."
  },
  {
    "name": "Girls PG Near Hinjewadi",
    "description": "Shree Swami Samarth offers a secure and women-friendly Girls PG near Hinjewadi IT Park with female staff, CCTV security, daily meals, and well-furnished rooms. Whether you’re a student or professional, we ensure safety and comfort just minutes from major offices and colleges."
  },
  {
    "name": "Boys PG Near Hinjewadi",
    "description": "Our Boys PG near Hinjewadi is tailored for male professionals and students looking for a hassle-free stay. Shree Swami Samarth PG provides clean rooms, fast Wi-Fi, meals, and quiet surroundings, all near top tech companies in Hinjewadi’s Phase 1 and Phase 2."
  }
],
"tableData": [
  ["Paying Guest Near Hinjewadi IT Park Pune", "PG Near Hinjewadi Phase 1"],
  ["PG Near Hinjewadi Phase 2", "PG Near Infosys Hinjewadi"],
  ["PG Near Tech Mahindra Hinjewadi", "Hostels Near Hinjewadi IT Park"],
  ["PG for Working Professionals Near Hinjewadi", "Affordable PG Near Hinjewadi"],
  ["Luxury PG Near Hinjewadi IT Park", "Monthly PG Near Hinjewadi"],
  ["Girls PG Near Hinjewadi", "Boys PG Near Hinjewadi"]
],




"whychoose": [
    {
        "WhyChooseheading": "Paying Guest Near Hinjewadi IT Park – Comfort Meets Convenience",
        "WhyChoosedescription": "Shree Swami Samarth PG offers the ideal PG accommodation near Hinjewadi IT Park for working professionals and interns. With a strategic location, furnished rooms, delicious meals, and all essential services included, we ensure a hassle-free and peaceful living experience just minutes from your office."
    },
    {
        "WhyChooseheading": "Strategically Located for Quick Access to IT Companies",
        "WhyChoosedescription": "Situated close to Phase 1, 2, and 3 of Hinjewadi IT Park, our PG saves you hours in daily commute. Whether you work at Infosys, Wipro, Cognizant, TCS, or any nearby tech company, you can reach your workplace quickly via shared cabs, buses, or bike rides."
    },
    {
        "WhyChooseheading": "Furnished Rooms for a Comfortable Stay",
        "WhyChoosedescription": "All rooms come fully equipped with a bed, mattress, wardrobe, fan, study table, and high-speed Wi-Fi. Choose from single, double, or triple sharing based on your preference. Rooms are designed for comfort and privacy—perfect for professionals who value quiet after work."
    },
    {
        "WhyChooseheading": "Tasty, Home-Cooked Meals Three Times a Day",
        "WhyChoosedescription": "Enjoy freshly prepared, nutritious meals served daily, including breakfast, lunch, and dinner. We maintain strict hygiene in our kitchen and offer both veg and non-veg options, so you always feel at home—especially during long workweeks."
    },
    {
        "WhyChooseheading": "Peaceful, Work-Friendly Environment",
        "WhyChoosedescription": "Designed for working individuals, our PG provides a calm, disciplined, and respectful atmosphere. With noise-free zones, a stable internet connection, and private spaces, it's an ideal setup for those working from home or studying after hours."
    },
    {
        "WhyChooseheading": "Affordable and All-Inclusive Rent Packages",
        "WhyChoosedescription": "Our monthly PG rent near Hinjewadi IT covers everything—stay, food, Wi-Fi, housekeeping, laundry, and electricity. No brokerage or hidden costs. Choose flexible rental options based on your work duration, project timelines, or internship period."
    },
    {
        "WhyChooseheading": "24/7 Security and Emergency Support",
        "WhyChoosedescription": "Your safety is our priority. Our PG is equipped with CCTV cameras, biometric entry, and on-site staff. Whether you're returning late from work or need assistance at night, we offer round-the-clock support for a secure living experience."
    },
    {
        "WhyChooseheading": "Ideal for IT Employees, Interns, and Remote Workers",
        "WhyChoosedescription": "Whether you're a full-time tech employee, a contract-based professional, or a short-term intern, our PG near Hinjewadi is built to suit your lifestyle—offering flexibility, reliability, and all the comforts of home, just minutes from your workplace."
    }
]




















    }

const faqData = [
    {
        question: "How can I book a paying guest near Hinjewadi IT Park at Shree Swami Samarth PG?",
        answer: "You can book a PG near Hinjewadi IT Park by calling us at +91 9594917913 or visiting the property. Online booking and virtual tour options are also available."
    },
    {
        question: "How far is your PG from Hinjewadi IT Park?",
        answer: "Our PG is located just a short commute away from Hinjewadi Phase 1, 2, and 3 — ideal for IT professionals working in the area."
    },
    {
        question: "Is your PG near Hinjewadi IT Park suitable for working professionals?",
        answer: "Yes, our PG is designed especially for IT professionals, offering a quiet, clean, and professional environment."
    },
    {
        question: "What amenities are available at your PG near Hinjewadi IT Park?",
        answer: "We offer fully furnished rooms, high-speed Wi-Fi, vegetarian meals, daily housekeeping, laundry service, power backup, and 24/7 security."
    },
    {
        question: "Is food included in the rent at your PG near Hinjewadi IT?",
        answer: "Yes, fresh and hygienic vegetarian meals are included in the rent — served for breakfast, lunch, and dinner."
    },
    {
        question: "Do you offer single occupancy near Hinjewadi IT Park?",
        answer: "Yes, we offer single, double, and triple sharing rooms with flexible pricing to suit your needs."
    },
    {
        question: "Is transport or shuttle available from your PG to Hinjewadi offices?",
        answer: "Many of our residents use shared cabs or bikes. While we don't offer shuttle services directly, our location makes commuting easy and affordable."
    },
    {
        question: "Is there a minimum stay period at your PG near Hinjewadi IT Park?",
        answer: "Yes, the minimum stay is one month. Long-term stays are welcome and may come with discounted rates."
    },
    {
        question: "Is the PG near Hinjewadi safe and secure?",
        answer: "Absolutely. Our PG is equipped with 24/7 CCTV cameras, secure entry, and onsite staff for resident safety."
    },
    {
        question: "How do I contact Shree Swami Samarth PG for bookings near Hinjewadi IT?",
        answer: "Call us directly at +91 9594917913 for availability, pricing, and to schedule a property visit."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rohan Salve',
        designation: 'Software Engineer, Infosys Hinjewadi Phase 2',
        rating: [1, 1, 1, 1, 1],
        text: '“Perfect location for anyone working in Hinjewadi IT Park. Clean PG, great food, and peaceful environment. Highly recommended.”',
    },
    {
        name: 'Ms. Kavita Bhandari',
        designation: 'QA Analyst, Cognizant Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“I chose this PG because it’s near my office, and I’m glad I did. Comfortable rooms and the food is just like home.”',
    },
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Paying Guest Near Hinjewadi IT Park Pune",
  "image": "https://swamisamarthpg.com/assets/images/pg-near-hinjewadi-it-park.jpg", // Replace with actual image URL
  "description": "Affordable and luxury paying guest accommodations near Hinjewadi IT Park, Pune. Ideal for working professionals and students with options near Infosys, Tech Mahindra, and other IT hubs.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1750"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8800",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/pg-near-hinjewadi-it-park"  // Replace with actual page URL if different
  }
};







    return (
        <div>
<Helmet>
  <title>Paying Guest Near Hinjewadi IT Park Pune | Affordable & Luxury PG</title>
  <meta 
    name="description" 
    content="Find affordable and luxury paying guest accommodations near Hinjewadi IT Park, Pune. Options for working professionals and students near Infosys, Tech Mahindra, and other IT hubs." 
  />
  <meta 
    name="keywords" 
    content="Paying Guest Near Hinjewadi IT Park Pune, PG Near Hinjewadi Phase 1, PG Near Hinjewadi Phase 2, PG Near Infosys Hinjewadi, PG Near Tech Mahindra Hinjewadi, Hostels Near Hinjewadi IT Park, PG for Working Professionals Near Hinjewadi, Affordable PG Near Hinjewadi, Luxury PG Near Hinjewadi IT Park, Monthly PG Near Hinjewadi, Girls PG Near Hinjewadi, Boys PG Near Hinjewadi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Payingguestnearhinjewadiitpark;